import { useAuth0 } from '@auth0/auth0-react';
import { Box, IconButton, Tooltip } from '@mui/material';
import VisibilityOffTwoToneIcon from '@mui/icons-material/VisibilityOffTwoTone';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import { usePrivacyMode } from 'src/contexts/PrivacyModeContext';

export const PRIVACY_MODE_TOOLTIP =
  'Privacy mode — hide dollar amounts and share counts while keeping percentages visible.';

/**
 * The icon's own on/off state is the only indicator that privacy mode is active: there is
 * deliberately no banner and no coloured header strip.
 */
export const PrivacyModeToggle = () => {
  const { isAuthenticated } = useAuth0();
  const { privacyMode, isLoading, isSaving, updatePrivacyMode } = usePrivacyMode();

  if (!isAuthenticated) {
    return null;
  }

  const handleClick = () => {
    void updatePrivacyMode(!privacyMode).catch((error) => {
      console.error('Failed to update privacy mode selection:', error);
    });
  };

  return (
    <Tooltip arrow title={PRIVACY_MODE_TOOLTIP}>
      {/* A disabled IconButton fires no pointer events, so MUI needs a wrapper to anchor the tooltip.
          The wrapper also carries the toggle's own trailing margin, mirroring DisplayCurrencySelector,
          so the spacing disappears together with the control instead of leaving a phantom spacer. */}
      <Box component="span" sx={{ display: 'inline-flex', mr: { xs: 1, sm: 2 } }}>
        <IconButton
          aria-label="Privacy mode"
          aria-pressed={privacyMode}
          color="primary"
          data-testid="privacy-mode-toggle"
          disabled={isLoading || isSaving}
          onClick={handleClick}
        >
          {privacyMode ? (
            <VisibilityOffTwoToneIcon fontSize="small" />
          ) : (
            <VisibilityTwoToneIcon fontSize="small" />
          )}
        </IconButton>
      </Box>
    </Tooltip>
  );
};
